import * as React from "react";

import HeroBan from "../../components/HeroBan";
import { useStaticQuery, graphql } from "gatsby";
import Layout from "../../components/layout";

const HRVSystems = ({ pageContext }) => {
  const wpdata = useStaticQuery(graphql`
    {
      wp {
        page(id: "residential/hrv-systems", idType: URI) {
          residentialHRV {
            summaryLink {
              target
              title
              url
            }
            summaryImage {
              altText
              sourceUrl
            }
            summaryContent
            image {
              altText
              sourceUrl
            }
            hrvItems {
              content
              heading
              image {
                altText
                sourceUrl
              }
            }
            heroLink {
              target
              title
              url
            }
            heroHeading
            heroImage {
              altText
              sourceUrl
            }
            heroContent
            heroBackgroundColor
          }
        }
      }
    }
  `);
  const data = wpdata?.wp?.page?.residentialHRV || {};

  return (
    <Layout pageContext={pageContext}>
      <HeroBan
        image={data?.heroImage?.sourceUrl}
        color={data?.heroBackgroundColor}
      >
        <h5>{data?.heroHeading}</h5>
        <p>{data?.heroContent}</p>
        <a href={data?.heroLink?.url} target={data?.heroLink?.target}>
          {data?.heroLink?.title}
        </a>
      </HeroBan>
      <div className="flex flex-wrap lg:flex-nowrap max-w-7xl mx-auto py-24 w-11/12 md:w-4/5 lg:w-full xl:w-full 2xl:w-4/5 overflow-hidden text-black">
        <img
          className="md:h-80"
          src={data?.summaryImage?.sourceUrl}
          alt={data?.summaryImage?.altText}
        ></img>
        <div className="flex flex-col lg:mx-10">
          <div
            dangerouslySetInnerHTML={{ __html: data?.summaryContent }}
            className="text-xl leading-9 lg:mt-0 mt-10 "
          ></div>
          <a
            className="bg-tan text-xl text-black uppercase font-anton  px-20 py-3 mt-5 mr-auto"
            href={data?.summaryLink?.url}
            target={data?.summaryLink?.target}
          >
            {data?.summaryLink?.title}
          </a>
        </div>
      </div>

      <div style={{ backgroundColor: "#F8F8F8" }}>
        <div className="flex flex-wrap justify-between max-w-7xl mx-auto py-20 w-11/12 md:w-4/5 lg:w-full xl:w-full 2xl:w-4/5 overflow-hidden text-black">
          {data?.hrvItems?.map((v, i) => (
            <div
              key={i}
              className="my-4 mx-auto max-w-sm w-full overflow-hidden md:w-full lg:w-1/3 xl:w-1/3"
            >
              <img
                className="w-full mx-auto mb-10"
                src={v?.image?.sourceUrl}
                alt={v?.image?.altText}
              ></img>
              <h5 className="text-black text-4xl my-2">{v?.heading}</h5>
              <p className="lg:h-80 text-xl leading-9">{v?.content}</p>
            </div>
          ))}
        </div>
      </div>
      <img
        className="max-w-screen-xl mx-auto my-20 w-full"
        src={data?.image?.sourceUrl}
        alt={data?.image?.altText}
      ></img>
    </Layout>
  );
};

export default HRVSystems;
